// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"styles_pageWrapper__srAgo","rightBlock":"styles_rightBlock__3OkAD","profitWrapper":"styles_profitWrapper__3WgFz","separator":"styles_separator__3Ewc4"};